var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticStyle:{"margin-right":"10px"},attrs:{"type":"primary","size":"mini","icon":"el-icon-download"},on:{"click":_vm.downloadExcel}},[_vm._v("导出汇总表")])}
var staticRenderFns = []

export { render, staticRenderFns }